import Select, { components } from "react-select";
import { ReactComponent as RiArrowDownSLine } from '@/assets/icons/ri-arrow-down-s-line.svg';

const IndicatorsContainer = () => <div className="text-black-primary">
    <RiArrowDownSLine />
</div>

const Control = ({ children, ...props }) => (
    // @ts-ignore
    <components.Control {...props}>
         <div className="flex min-w-[200px] flex-row w-full justify-between items-center px-4 text-jsm font-normal">
             {children}
         </div>
    </components.Control>
);

const IndicatorSeparator = () => null

const GenericSelect = (props) => <Select
    {...props}
    components={{
        Control: (p) => Control({...p}),
        IndicatorsContainer,
        IndicatorSeparator,
    }}
/>

export default GenericSelect;